$(document).ready(function() {
  // 手机导航
  $('.menuBtn').append('<b></b><b></b><b></b>');
  $('.menuBtn').click(function(event) {
      $(this).toggleClass('open');
      $('.nav').stop().slideToggle();
  });

  var _winw = $(window).width();
  if( _winw > 959 ){
      $('.nav li').hover(function() {
          $(this).find('.sub').stop().slideDown();
          if ($(this).find('.sub').length) {
              $(this).addClass('ok');
              $('.header').addClass('on');
          } else {
              $('.header').removeClass('on');
          }
      }, function() {
          $(this).removeClass('ok');
          $(this).find('.sub').stop().slideUp();
      });
      $('.nav').mouseleave(function(event) {
          if ($('.header').hasClass('on')) {
              $('.header').removeClass('on');
          };
      });
  }else{
      $('.nav .v1').click(function() {
          if ($(this).siblings('.sub').length) {
              $(this).parents('li').siblings('li').find('.sub').stop().slideUp();
              $(this).siblings('.sub').stop().slideToggle();
              return false;
          }
      });
  }
  $('.h-picuser').hover(function() {
      $(this).find('.h-box1').stop().slideDown();
      if ($(this).find('.h-box1').length) {
          $('.h-picuser').addClass('on');
      } else {
          $('.h-picuser').removeClass('on');
      }
  }, function() {
      $(this).find('.h-box1').stop().slideUp();
  });
  // 弹出框
  $('.myfancy').click(function () {
      var _id = $(this).attr('href');
      $(_id).fadeIn("normal");
  });
  $('.m-pop .pop-bg,.close').click(function () {
      $(this).parents('.m-pop').fadeOut("normal");
  });
  

  // 选项卡 鼠标点击
  $(".TAB_CLICK li").click(function(){
    var tab=$(this).parent(".TAB_CLICK");
    var con=tab.attr("id");
    var on=tab.find("li").index(this);
    $(this).addClass('on').siblings(tab.find("li")).removeClass('on');
    $(con).eq(on).show().siblings(con).hide();
  });
  $('.TAB_CLICK').each(function(index, el) {
      if($(this).find('li.on').length){
          $(this).find("li.on").trigger('click');
      }else{
          $(this).find("li").filter(':first').trigger('click');
      }
  });
  
});